import * as React from "react";
import { Backdrop, Button, Fade, Modal } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

export const NewSensorDialog = ({
  handleNewAccount
}: {
  handleNewAccount: () => void;
}) => {
  const [open, setOpen] = React.useState(true);
  const handleClose = (event: never, reason: string) => {
    if (reason === "backdropClick") return;
    setOpen(false);
  };

  const handleNewAccountClick = () => {
    setOpen(false);
    handleNewAccount();
  };

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Grid container justifyContent="center">
              <Typography
                id="transition-modal-title"
                variant="h4"
                component="h2"
              >
                UUSI ÄLÄKKÄ
              </Typography>
              <Button
                style={{ margin: 10 }}
                onClick={() => setOpen(false)}
                variant={"outlined"}
              >
                Minulla on käyttäjätili
              </Button>
              <Button onClick={handleNewAccountClick} variant={"outlined"}>
                Uusi asiakas
              </Button>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};
